import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { faSearch } from '@fortawesome/pro-solid-svg-icons';

import LoadingSpinner from 'components/loading_spinner';

import DuplicatesPageHeader from './duplicates_page_header';
import DuplicatesPageTopbar from './duplicates_page_topbar';
import DuplicatesTable from './duplicates_table';

import { getDuplicatePropertiesCount, isLoading } from '../../store/selectors/duplicates';
import DuplicatesPagination from 'bundles/research/index/properties/duplicates/duplicates_pagination';
import EmptyState from 'shared/empty_state';

function renderEmptyState() {
  return (
    <div className="p-4" name="no-results-card">
      <EmptyState header="No duplicate properties found" icon={faSearch} />
    </div>
  );
}

function renderTable() {
  return (
    <>
      <DuplicatesTable />
      <DuplicatesPagination />
    </>
  );
}

function renderResults(isLoading, totalCount) {
  if (isLoading) return <LoadingSpinner />;
  if (totalCount > 0) return renderTable();
  return renderEmptyState();
}

export function DuplicatePropertiesView({ isLoading, totalCount }) {
  return (
    <>
      <DuplicatesPageHeader />
      <DuplicatesPageTopbar />
      {renderResults(isLoading, totalCount)}
    </>
  );
}

DuplicatePropertiesView.propTypes = {
  isLoading: PropTypes.bool,
  totalCount: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  isLoading: isLoading(state),
  totalCount: getDuplicatePropertiesCount(state)
});

export default connect(mapStateToProps)(DuplicatePropertiesView);
